import { onError } from '@apollo/client/link/error';
import { createStandaloneToast } from '@chakra-ui/react';
import { ServerError } from '@apollo/client';

const { toast } = createStandaloneToast();

const SERVER_ERROR_MESSAGE =
  'Estamos teniendo problemas con nuestro servidor. Por favor, intenta nuevamente más tarde.';

const NETWORK_ERROR_MESSAGE = 'No se pudo conectar al servidor. Verifica tu conexión a internet y vuelve a intentarlo.';

export const createErrorLink = () => {
  return onError(({ networkError }) => {
    let errorMessage: string | null = null;
    let errorTitle = 'Error';

    if (networkError) {
      const serverError = networkError as ServerError;

      if (serverError.statusCode && serverError.statusCode >= 500 && serverError.statusCode < 600) {
        errorMessage = SERVER_ERROR_MESSAGE;
        errorTitle = 'Problema en el servidor';
        console.error(`[Apollo Error] ${serverError.statusCode}: ${errorMessage}`);
      }

      if (!serverError.statusCode) {
        errorMessage = NETWORK_ERROR_MESSAGE;
        errorTitle = 'Error de conexión';
        console.error(`[Apollo Error] Error de conexión: ${errorMessage}`);
      }
    }

    if (errorMessage) {
      toast({
        title: errorTitle,
        description: errorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  });
};
